export default "__VITE_ASSET__9d18f458__"